export default
	{
    retrieveToken(state, token) {
      state.token = token;
    },
    destroyToken(state) {
      state.token = null;
    },
    setName(state, name) {
      state.name = name;
    },
    setEmail(state, email) {
      state.email = email;
    },
    setScores(state, scores) {
      state.scores = scores;
    },
    setBalance(state, balance) {
      state.balance = balance;
    },
    setRates(state, rates) {
      state.rates = rates;
    },
    setGiftPayBalance(state, giftPayBalance) {
      state.giftPayBalance = giftPayBalance;
    },
    setTransactions(state, transactions) {
      state.transactions = transactions;
    },
    setAdminTransactions(state, adminTransactions) {
      state.adminTransactions = adminTransactions;
    },
    setAdminGameTransactions(state, adminGameTransactions) {
      state.adminGameTransactions = adminGameTransactions;
    },
    setRewards(state, rewards) {
      state.rewards = rewards;
    },
    setAdminRewards(state, adminRewards) {
      state.adminRewards = adminRewards;
    },
    setAdminFeatures(state, adminFeatures) {
      state.adminFeatures = adminFeatures;
    },
    setIsAdmin(state, isAdmin) {
      state.isAdmin = isAdmin;
    },
    setPaymentMethods(state, paymentMethods) {
      state.paymentMethods = paymentMethods;
    },
    setPaymentAmounts(state, paymentAmounts) {
      state.paymentAmounts = paymentAmounts;
    },
    setShowamount(state, showamount) {
      state.showamount = showamount;
    },
    setShowdaminamount(state, showdaminamount) {
      state.showdaminamount = showdaminamount;
    },
    setShowkelamount(state, showkelamount) {
      state.showkelamount = showkelamount;
    }, 
    setWinBankResponseAmount(state, winbankresponseamount) {
      state.winbankresponseamount = winbankresponseamount;
    },
    setWinBankResponseType(state, winbankresponsetype) {
      state.winbankresponsetype = winbankresponsetype;
    },
    setFirstName(state, firstname) {
      state.firstname = firstname;
    },
    setLastName(state, lastname) {
      state.lastname = lastname;
    },
    setRegion(state, region) {
      state.region = region;
    },
    seteditProfileMessage(state, editprofilemessage) {
      state.editprofilemessage = editprofilemessage;
    },
    retrieveDamnToken(state, token) {
      state.damntoken = token;
    },
    setadserverSessionId(state, adserversessionid) {
      state.adserversessionid = adserversessionid;
    },
    setBannerImage(state, payload){
      state.bannerimage = payload;
    },
    setQuizStarBannerList(state, payload){
      state.quizstarbannerlist = payload;
    },
    setRegions(state,payload){
      state.regions = payload;
    },
    setAvatar(state, payload){
      state.avatar = payload;
    },
    setUserid(state, payload){
      state.userid = payload;
    },
    setPaypal(state, payload){
      state.paypalemail = payload; 
    },
    setUsername(state, username) {
      state.username = username;
    },
    setDob(state, dob) {
      state.dob = dob;
    },
    setGender(state, gender) {
      state.gender = gender;
    },
    setStateid(state, stateid) {
      state.stateid = stateid;
    },
    setCityname(state, cityname) {
      state.cityname = cityname;
    },
    setSuburb(state, suburb) {
      state.suburb = suburb;
    },
    setCreditBalance(state,payload){
       state.creditBalance = payload;
    }
  }
